export default __webpack_public_path__ + "static/media/video-img.b805bd0e.png";